export default __webpack_public_path__ + "static/media/6N5A3895_tn.50a07381.jpg";